import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";

export class BusinessCategoryService extends BaseService {
  static async supportedBusinessCategories(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    const url: string = "business-categories";
    return BusinessCategoryService.getPublicApiClient().get(url);
  }
}
export default BusinessCategoryService;
